<template>
  <ul class="form-item-list">
    <li><h3>직업을 입력해주세요</h3></li>
    <li>
      <element-textbox
        v-model="formData.주업무.value"
        :error="formData.주업무.error"
        :label="formData.주업무.label"
        :placeholder="formData.주업무.placeholder"
      />
    </li>
    <li>
      <element-textbox
        v-model="formData.근무처.value"
        :error="formData.근무처.error"
        :label="formData.근무처.label"
        :placeholder="formData.근무처.placeholder"
      />
    </li>
    <li>
      <element-textbox
        v-model="formData.근무지역.value"
        :error="formData.근무지역.error"
        :label="formData.근무지역.label"
        :placeholder="formData.근무지역.placeholder"
      />
    </li>
    <li>
      <element-textbox
        v-model="formData.하시는일.value"
        :error="formData.하시는일.error"
        :label="formData.하시는일.label"
        :placeholder="formData.하시는일.placeholder"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Job',
  props: ['formData'],
  data() {
    return {
      job: '',
      company: '',
      region: '',
      detail: '',
    }
  },
  created() {
    console.log(this.formData);
  },
  watch: {
    'formData.주업무.value' : function (n) {
      this.update('주업무', n);
    },
    'formData.근무처.value' : function (n) {
      this.update('근무처', n);
    },
    'formData.근무지역.value' : function (n) {
      this.update('근무지역', n);
    },
    'formData.하시는일.value' : function (n) {
      this.update('하시는일', n);
    },
  },
  methods: {
    update(type, value) {
      if (value !== '') {
        this.$emit('update', { type, value });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    h3 {
      font-size: 18px !important;
    }
  }
}
</style>